import { render, staticRenderFns } from "./Price.vue?vue&type=template&id=7772d3b5&scoped=true"
import script from "./Price.vue?vue&type=script&lang=js"
export * from "./Price.vue?vue&type=script&lang=js"
import style0 from "./Price.vue?vue&type=style&index=0&id=7772d3b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7772d3b5",
  null
  
)

export default component.exports